import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export default function StripeAccounts({accounts, team, close, proceed, invoice, account}) {
    const [selectedStripeAccount, setSelectedStripeAccount] = useState(account)

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <div className='form-group'>
                    <label htmlFor='stripe-account'>Select Stripe Account</label>
                    <div className="input-group">
                        <Select
                            className="w-100 select-audience"
                            classNamePrefix="select-audience"
                            value={selectedStripeAccount}
                            onChange={(value) => setSelectedStripeAccount(value)}
                            options={accounts}
                            getOptionLabel={account => `${account.name}`}
                            getOptionValue={account => account }
                        />
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => proceed(selectedStripeAccount)} type="button" className="btn btn-primary mr-2" disabled={!selectedStripeAccount}>
                        Proceed
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
